import React, { useState } from "react";
import { QUERY_ENDPOINTS } from "@/framework/utils/query-endpoints";
import { getUrqlClient } from "@/lib/urql-client";
import { sanitize } from "@/framework/utils/sanitize";
import Application from "@/components/pages/job/application";
import Card from "@/components/pages/job/card";
import Content from "@/components/pages/job/content";
import Section from "@/components/ui/section";
import Image from "next/image";
import Seo from "@/utils/seo";
export default function Job({ jobOpening }) {
  const handleStateApplication = () => {
    setShowApplication(!showApplication);
  };
  const [showApplication, setShowApplication] = useState(false);
  const seo = {
    slug: `job-openings/${jobOpening?.slug}`,
    metaTitle:
      jobOpening?.seo?.metaTitle ??
      jobOpening?.title ??
      "Your One-Stop Destination for Luxury Interiors - Chalk Studio",
    metaDescription:
      jobOpening?.seo?.metaDescription ?? jobOpening?.description,
  };
  return (
    <>
      <Seo seo={seo} />
      <div className="flex flex-col lg:flex-row w-full ">
        <div className="w-full lg:w-[290px] md:h-[450px] h-[400px] lg:h-screen shrink-0 lg:sticky lg:top-0 relative">
          <Image
            src={
              jobOpening?.image?.data?.attributes?.url ??
              "/images/placeholder.svg"
            }
            priority
            alt={
              jobOpening?.image?.data?.attributes?.alternativeText ??
              jobOpening?.image?.data?.attributes?.name ??
              "job opening banner"
            }
            fill
            className="object-cover object-center"
            sizes="(max-width: 479px) 400px,(max-width: 767px) 800px,(max-width: 991px) 800px, 800px"
          />
          <div className="absolute top-0 left-0 w-full h-full bg-black/10" />
        </div>

        <Section className={"overflow-y-auto"}>
          <Card jobOpening={jobOpening} />
          {showApplication ? (
            <Application jobOpening={jobOpening} />
          ) : (
            <Content
              handleState={handleStateApplication}
              jobOpening={jobOpening}
            />
          )}
        </Section>
      </div>
    </>
  );
}
export async function getStaticProps({ params = {} } = {}) {
  let props = {};
  const client = await getUrqlClient();

  try {
    const { data } = await client.query(
      QUERY_ENDPOINTS.JOB_BY_SLUG,
      {
        slug: params?.slug,
      },
      {
        requestPolicy: "network-only",
      }
    );
    function isObjectEmptyOrNull(obj) {
      if (obj === null || obj === undefined) {
        return true;
      }
      if (Object.keys(obj).length === 0) {
        return true;
      }
      return false;
    }

    if (isObjectEmptyOrNull(data?.jobOpening)) {
      return {
        notFound: true,
      };
    }
    props = {
      jobOpening: sanitize(data?.jobOpening?.data) ?? "",
    };
  } catch (error) {
    console.log(error);
  }
  return {
    props,
    revalidate: 1,
  };
}
export async function getStaticPaths() {
  let paths = [];
  const client = await getUrqlClient();
  try {
    const { data } = await client.query(
      QUERY_ENDPOINTS.ALL_JOBS,
      {
        start: 0,
        limit: 12,
        sortBy: ["order:asc"],
        filter: {},
      },
      {
        requestPolicy: "network-only",
      }
    );

    const jobOpenings =
      data?.jobOpenings?.data.map((row) => sanitize(row)) || [];

    paths = jobOpenings.map((jobOpening) => {
      return {
        params: {
          slug: jobOpening.slug,
        },
      };
    });
  } catch (error) {
    console.log(error);
  }
  return {
    paths,
    fallback: "blocking",
  };
}
